import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "hooks/useAuth";
import getDecodedToken from 'services/getDecodedToken';
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RequireAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();
console.log(auth);

  if (!auth?.accessToken) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  if (!auth?.roles?.find(role => allowedRoles?.includes(role))) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
export default RequireAuth